import { platformOpsApi } from ".";

export interface ExpLicenseResponseDto {
  companyId: number;
  companyLetter: string;
  companyName: string;
  databaseName: string;
}

export interface UpdateExpressCompanyNameResponseDto {
  expLicense: ExpLicenseResponseDto;
  errorMessage: string | null;
}

export interface ExpressCompanyNameAuditDto {
  id: number;
  serverId: string;
  companyId: number;
  databaseLetter: string;
  oldCompanyName: string;
  newCompanyName: string;
  status: string;
  errorMessage: string | null;
  dateRequested: string;
  dateCompleted: string | null;
  requestedBy: string;
}

export interface RenameCompanyResult {
  data: UpdateExpressCompanyNameResponseDto;
  status: number;
}

export const renameCompany = async (
  serverId: string,
  companyId: number,
  databaseLetter: string,
  companyName: string
): Promise<RenameCompanyResult> => {
  const response = await platformOpsApi.patch<UpdateExpressCompanyNameResponseDto>(
    `/v1/express/server/${serverId}/company/${companyId}/database/${databaseLetter}/companyname`,
    { companyName },
    { validateStatus: (s) => s === 200 || s === 207 }
  );
  return { data: response.data, status: response.status };
};

export const getCompanyNameAudits = async (): Promise<ExpressCompanyNameAuditDto[]> => {
  const response = await platformOpsApi.get<ExpressCompanyNameAuditDto[]>(
    "/v1/express/audit/companyname"
  );
  return response.data;
};
